import { render } from "./OMemberPointsWarning.vue?vue&type=template&id=2d8e2366&scoped=true"
import script from "./OMemberPointsWarning.vue?vue&type=script&lang=js"
export * from "./OMemberPointsWarning.vue?vue&type=script&lang=js"

import "./OMemberPointsWarning.vue?vue&type=style&index=0&id=2d8e2366&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8e2366"]])

export default __exports__